import React from 'react';
import PropTypes from 'prop-types';

//import "react-table/react-table.css";
import { contextMenu } from 'react-contexify';
import EditableGridSelectionStorage from './EditableGrideSelectionStorage.js'
import BaseTable, {AutoResizer, Column} from "react-base-table";
import styled, {createGlobalStyle} from "styled-components";
//import { Overlay } from 'react-overlays';
import EditableInputCell from './EditableInputCell.js'
import EditableDateCell from './EditableDateCell.js'
import EditableDropdownCell from './EditableDropdownCell.js'
import ReadOnlyCell from './ReadOnlyCell.js'
import './RowNumberCell.css';
// import EditableDropdownCell2 from './EditableDropdownCell2.js'


const CellContainer = styled.div`
  display: flex;
  flex: 1 0 100%;
  align-items: center;
  height: 100%;
  overflow: hidden;
  margin: 0 -5px;
  border: 1px dashed transparent;
`;

const GlobalStyle = createGlobalStyle`
  .BaseTable__row:hover,
  .BaseTable__row--hover {
    ${CellContainer} {
      border: 1px dashed #ccc;
    }
  }
`;

const Empty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
`;

const RowNumberCell = styled.div`
  width: 100%;
  height: 24px;
  padding-right: 5px;
  padding-left: 5px;
  text-align: center;
  background-color: #ccc;
`;

const SelectableTable = styled(BaseTable)`
  .row-selected {
    background-color: #e3e3e3;
  }
  .row-invalid {
    background-color: #f5d8d3;
  }
`

const GroupCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &:not(:last-child) {
    border-right: 1px solid lightgray;
  }
`

//#3cea0326

const renderers = {
  string: EditableInputCell,
  dropdown: EditableDropdownCell,
  date: EditableDateCell,
  stringReadOnly: ReadOnlyCell,
};

const Cell = cellProps => {
  const format = cellProps.column.type || 'string'
  const CellRenderer = renderers[format] || renderers.string
//editing={cellProps.container.props.isEditing(cellProps.rowIndex, cellProps.columnIndex)}
  return (<CellRenderer {...cellProps} />)
};

/*
const DefaultHeaderRenderer = ({ className, column, columnIndex }) => <div className={className}>{column.title}</div>;

DefaultHeaderRenderer.propTypes = {
  className: PropTypes.string,
  column: PropTypes.object,
  columnIndex: PropTypes.number,
};

const SubtotalHeaderRenderer = ({ className, column, columnIndex }) => <div className={className}>{column.title}</div>;

SubtotalHeaderRenderer.propTypes = {
  className: PropTypes.string,
  column: PropTypes.object,
  columnIndex: PropTypes.number,
};


const headerRenderers = {
  defaultRenderer: DefaultHeaderRenderer,
  subtotalRenderer: SubtotalHeaderRenderer
};

const HeaderCell = cellProps => {
  const HeaderCellRenderer = cellProps.column.headerSubTotalGetter? headerRenderers.subtotalRenderer : headerRenderers.defaultRenderer
  return (<HeaderCellRenderer {...cellProps} />)
};*/

const components = {
  TableCell: Cell,
  //TableHeaderCell: HeaderCell
};

// eslint-disable-next-line react/prop-types
const rowNumberRenderer = ({ rowIndex }) => (
  <RowNumberCell key={""+rowIndex+":"+0}>{rowIndex+1}</RowNumberCell>
);

//
// const rowRenderer = ({ rowData, rowIndex, cells, columns }) => {
//   cells[0].style =
//   const span = columns[spanIndex].colSpan({ rowData, rowIndex })
//   if (span > 1) {
//     let width = cells[spanIndex].props.style.width
//     for (let i = 1; i < span; i++) {
//       width += cells[spanIndex + i].props.style.width
//       cells[spanIndex + i] = null
//     }
//     const style = {
//       ...cells[spanIndex].props.style,
//       width,
//       backgroundColor: 'lightgray',
//     }
//     cells[spanIndex] = React.cloneElement(cells[spanIndex], { style })
//   }
//   return cells
// }


class EditableGrid2 extends React.Component {

    constructor(props) {
        super(props);
        this.onContextMenu = this.onContextMenu.bind(this);
        this._rowClassName = this._rowClassName.bind(this);
        this._headerRenderer = this._headerRenderer.bind(this);
        this.state = {
          version: 0,
          editingRowIndex: -1,
          editingColumnIndex: -1
        };
        this.selectionStorage = props.selectionStorage;
        if (!props.selectionStorage) {
          this.selectionStorage = new EditableGridSelectionStorage([]);
        }
        this._table = React.createRef();
        this.headerHeightsWithSubtotal = [30, 30];
        this.headerHeights = [30];
    }

    componentDidMount() {
      this.selectionStorage.subscribe(this);
    }

    componentWillUnmount() {
      this.selectionStorage.unsubscribe(this);
      this.selectionStorage.resetSelection();
    }

    onSelectionChange() {
      this.setState({
        version: this.state.version+1,
        editingRowIndex: -1,
        editingColumnIndex: -1
      });
    }

  // eslint-disable-next-line no-unused-vars
    _rowClassName({ rowData, rowIndex }){
      if (this.selectionStorage.isSelected(rowIndex)) {
        return 'row-selected';
      } else {
        return null;
      }
    }

  _prefixClass(className) {
    return `BaseTable__${className}`;
  }



  _headerRenderer({ cells, columns, headerIndex }){
    if (headerIndex === 1 || !this.props.subtotalHeader) {
      return cells;
    }

    const groupCells = [];
    let width = 0;
    for (let columnIndex =0; columnIndex< columns.length; columnIndex++) {
      let column = columns[columnIndex];
      if (column[BaseTable.PlaceholderKey]) {
        groupCells.push(cells[columnIndex]);
        continue;
      }
      width += cells[columnIndex].props.style.width
      const nextColumn= columns[columnIndex+1]
      if (column.headerSubTotalGetter || !nextColumn || nextColumn[BaseTable.PlaceholderKey] || nextColumn.headerSubTotalGetter ) {
        groupCells.push(
          <GroupCell
            key={`header-group-cell-${column.key}`}
            style={{ ...cells[columnIndex].props.style, width }}
          >
            {column.headerSubTotalGetter? column.headerSubTotalGetter({columns, column, columnIndex}): ""}
          </GroupCell>
        );
        width = 0;
      }

    }
    return groupCells
  }

    render() {
      let _columns = [{
        key: 'row',
        dataKey: 'row',
        title: '',
        width: 50,
        maxWidth: 50,
        // filterable: false,
        resizable: false,
        flexShrink: 0,
        frozen: Column.FrozenDirection.LEFT,
        cellRenderer: rowNumberRenderer,
        className: "RowNumberCell"
      }, ...this.props.columns];

      this._columns = _columns;
      //this.updateColumnCell(this.props.columns);rowProps, { columns, rowData, rowIndex }
      // eslint-disable-next-line no-unused-vars
      const rowProps = ({ rowData, rowIndex }) => {
        let result = {
          version: rowData.version/*,
          style: {
            background: this.selectionStorage.isSelected(rowIndex)? '#3cea0326': 'unset'
          }*/
        };
        if (this.props.menuId) {
          result.onContextMenu = this.onContextMenu
        }
        return result;
      };
      //rowEventHandlers
      const cellProps = ({ rowIndex, columnIndex }) => ({
        onClick: (event) => {
          console.log(`onClick  ${this.state.editingRowIndex}: ${this.state.editingColumnIndex} == ${rowIndex}: ${columnIndex}` );

          if (!event.ctrlKey) {
            // this.setState({
            //   editingRowIndex: rowIndex,
            //   editingColumnIndex: columnIndex
            // });
            // this._table.current.forceUpdateTable();
          }

          if ( columnIndex !== 0) {
            this.selectionStorage.resetSelection();
          } else if (event.ctrlKey){
            this.selectionStorage.toggleSelectedItem(rowIndex)
          } else {
            this.selectionStorage.resetSelection();
            this.selectionStorage.addSelectedItem(rowIndex);
            console.log("Clicking "+rowIndex+" row");
          } /*else {
            console.log("Clicking a new row");
            this.selectionStorage.resetSelection();
            this.props.onNewRowClick(event);
          }*/
        }
      });

      return (
        <>
          <GlobalStyle key="globalstyle"/>
          <AutoResizer key="autoresizer">
            {({ width, height }) => (
              <SelectableTable
                ref={this._table}
                fixed
                width={width}
                height={height}
                rowKey={this.props.uuidKey || "uuid"}
                columns={this._columns}
                data={this.props.data}
                headerHeight={this.props.subtotalHeader? this.headerHeightsWithSubtotal: this.headerHeights}
                rowHeight={30}
                cellProps={cellProps}
                rowProps={rowProps}
                rowClassName={this._rowClassName}
                components={components}
                emptyRenderer={<Empty>Table is empty</Empty>}
                isEditing={(rowIndex, columnIndex) => {
                  console.log(`isEditing  ${this.state.editingRowIndex}: ${this.state.editingColumnIndex} == ${rowIndex}: ${columnIndex}` );
                  return this.state.editingRowIndex === rowIndex && this.state.editingColumnIndex === columnIndex;
                }}
                stopEditing={(itemRowIndex, itemColumnIndex)=>{
                  if (!this.state.editingRowIndex === itemRowIndex || !this.state.editingColumnIndex === itemColumnIndex) {
                    console.warn("Received stopEditing event from "+itemRowIndex+":"+itemColumnIndex+" even though was editing: "+this.state.editingRowIndex+":"+this.state.editingColumnIndex)
                  }
                  this.setState({
                    editingRowIndex: -1,
                    editingColumnIndex: -1
                  });
                }}
                headerRenderer={this._headerRenderer}
              />)}
          </AutoResizer>
        </>

      )
    }




    onContextMenu(e){
      e.preventDefault();
      contextMenu.show({
        id: this.props.menuId,
        event: e,
        props: {
          selected: this.selectionStorage.getSelectedRows()
        }
      });
    }
}

EditableGrid2.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  selectionStorage: PropTypes.object,
  onContextMenu: PropTypes.func,
  onRowClick: PropTypes.func,
  onSelectionChange: PropTypes.func,
  onNewRowClick: PropTypes.func,
  dataKey: PropTypes.string,
  uuidKey: PropTypes.string,
  menuId: PropTypes.string,
  subtotalHeader: PropTypes.bool
};


export default EditableGrid2;